module.exports = __webpack_public_path__ + "static/logo-ccdf45f187b972043e648d196ac7c677.png";